import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ClientDetailsSkeleton = () => (
  <div className="container-fluid p-3">
    {/* Top Details (2 Columns) */}
    <div className="row mb-3">
      <div className="col-12 col-md-6 mb-3">
        <div className="row mb-2">
          <div className="col-12 col-md-3">
            <Skeleton height={25} width="100%" />
          </div>
          <div className="col-12 col-md-5">
            <Skeleton height={25} width="90%" />
          </div>
          <div className="col-12 col-md-4">
            <Skeleton height={25} width="90%" />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 col-md-3">
            <Skeleton height={25} width="100%" />
          </div>
          <div className="col-12 col-md-5">
            <Skeleton height={25} width="90%" />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 col-md-3">
            <Skeleton height={25} width="100%" />
          </div>
          <div className="col-12 col-md-5">
            <Skeleton height={25} width="90%" />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 col-md-3">
            <Skeleton height={25} width="100%" />
          </div>
          <div className="col-12 col-md-5">
            <Skeleton height={25} width="90%" />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 col-md-3">
            <Skeleton height={25} width="100%" />
          </div>
          <div className="col-12 col-md-5">
            <Skeleton height={25} width="90%" />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12 col-md-3">
            <Skeleton height={25} width="100%" />
          </div>
          <div className="col-12 col-md-5">
            <Skeleton height={25} width="90%" />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 mb-3">
        <Skeleton width="100%" height={25} className="mb-2" />
        <Skeleton width="100%" height={25} className="mb-2" />
      </div>
    </div>

    {/* Tab Skeleton */}
    <div className="mb-3">
      <div className="row mb-3">
        <div className="col-1">
          <Skeleton height={25} width="100%" />
        </div>
        <div className="col-1">
          <Skeleton height={25} width="100%" />
        </div>
        <div className="col-1">
          <Skeleton height={25} width="100%" />
        </div>
        <div className="col-1">
          <Skeleton height={25} width="100%" />
        </div>
        <div className="col-1">
          <Skeleton height={25} width="100%" />
        </div>
        <div className="col-1">
          <Skeleton height={25} width="100%" />
        </div>
      </div>
    </div>

    {/* Form Details (Multiple Sections in 2 Columns) */}
    <div className="row">
      <div className="col-12 col-md-6">
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>

          <div className="col-12 col-sm-6 col-md-4 mb-3" />
          <div className="col-12 col-sm-6 col-md-4 mb-3" />
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={75} />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6">
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>

          <div className="col-12 col-sm-6 col-md-8 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-2 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={75} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={35} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 col-sm-6 col-md-4 mb-3" />
          <div className="col-12 col-sm-6 col-md-4 mb-3">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-12 mb-3">
            <Skeleton width="100%" height={75} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

// No props needed here, as this is a static skeleton mimicking your UI

export default ClientDetailsSkeleton;
